<template>
  <div>
    <div class="placeholder page-heading-placeholder" v-if="loading">
      <p class="text text-title text-h-20"></p>
    </div>

    <div class="page-heading" v-else>
      <div class="heading">
        <h1>
          {{ title }}
        </h1>
      </div>
      <div class="buttons" align="right">
        <slot name="buttons"></slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PageHeading',
    props: {
      title: {
        type: String,
        required: true,
      },
      icon: {
        type: String,
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
      };
    },
  };
</script>

<style lang="scss">
  .page-heading-placeholder {
    margin-bottom: 15px;
    .text-title {
      width: 100px;
    }
    .text-breadcrumbs {
      width: 180px;
    }
  }
  .page-heading {
    margin:  0;
    // padding-left: 10px;
    display: flex;
    >div{
      flex: 1;
      &.heading{
        h1 {
          margin: 0px 0 30px;
          font-weight: 300;
          color: #fff;
        }
        flex: 2;
      }
      &.buttons {
        // align-content: right;
      }      
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/PageHeading.vue